import { tokens, gradients } from 'tamagui-config';

export enum Status {
  Good = 'good',
  Poor = 'poor',
  Error = 'error',
}

export function getGradientColors(status: Status): [string, string] {
  switch (status) {
    case Status.Poor:
      return [tokens.color.gradientPoorStart, tokens.color.gradientPoorEnd];
    case Status.Error:
      return [tokens.color.gradientErrorStart, tokens.color.gradientErrorEnd];
    case Status.Good:
    default:
      return [tokens.color.gradientGoodStart, tokens.color.gradientGoodEnd];
  }
}

export function getGlowColors(status: Status): string[] {
  switch (status) {
    case Status.Poor:
      return gradients.warning;
    case Status.Error:
      return gradients.error;
    case Status.Good:
    default:
      return [tokens.color.transparent];
  }
}

export function getIconColor(status: Status): string {
  return status === Status.Good ? tokens.color.goodGreen : tokens.color.black;
}

export function getStatusTextColor(status: Status): string {
  return status === Status.Good ? tokens.color.goodGreen : tokens.color.white12;
}

export function getIconBgColor(status: Status): string {
  switch (status) {
    case Status.Poor:
      return tokens.color.warning;
    case Status.Error:
      return tokens.color.error;
    case Status.Good:
    default:
      return tokens.color.transparentBorder;
  }
}
